












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Spinner from '@/components/Spinner.vue';
import ConnectionErrorContent from '@/components/ConnectionErrorContent.vue';

export interface Category {
	id: string;
	title: string;
    image: boolean;
    recipes: number;
}

@Component({
  components: {
    Spinner,
    ConnectionErrorContent,
  },
})
export default class CategoryList extends Vue {
    private status!: string;
    private categoryList!: Category[];
    private categoryListShown!: Category[];
    private catFilter!: string;
    private resetButton!: boolean;

    private data() {
        return {
            status: 'loading',
            categoryList: [],
            categoryListShown: [],
            catFilter: '',
            resetButton: false,
        };
    }

    private created() {
        this.$store.state.mobileSidebarVisible = false;
        this.$store.state.headerNavVisible = false;
        this.$store.state.menuVisible = false;
		this.loadData();
    }

    private loadData() {
        this.$http.get('categories/get/all').then((response: AxiosResponse) => {
			this.categoryList = response.data.map((val: any) => ({
				id: val.id,
				title: val.title,
                image: val.image,
                recipes: val.recipes,
            }));
            this.categoryListShown = this.categoryList.sort((a, b) => a.title.localeCompare(b.title));
            this.status = 'success';
		}).catch((error) => {
            this.status = 'error';
        });
    }

    private filter() {
        if (this.catFilter !== '') {
            this.resetButton = true;
        } else {
            this.resetButton = false;
        }
        const filter = this.catFilter.toUpperCase();
        const recipeList = this.categoryList;
        this.categoryListShown = [];

        for (let i = 0; i < recipeList.length; i++) {
            if (recipeList[i].title.toUpperCase().indexOf(filter) > -1) {
                this.categoryListShown.push(recipeList[i]);
            }
        }
    }

    private resetFilter() {
        this.resetButton = false;
        this.catFilter = '';
        this.categoryListShown = this.categoryList;
    }
}
